import auth from './auth';
import uiConfig from './ui-config';

export default [
  auth,
  uiConfig,
];
